import React, { ReactElement } from 'react';

import { ReactComponent as ChevronDoubleLeft } from './assets/chevron-double-left.svg';
import { ReactComponent as ChevronDown } from './assets/chevron-down.svg';
import { ReactComponent as ChevronUp } from './assets/chevron-up.svg';
import { ReactComponent as CodeSlash } from './assets/code-slash.svg';
import { ReactComponent as ColorSwatch } from './assets/color-swatch.svg';
import { ReactComponent as CubeTransparent } from './assets/cube-transparent.svg';
import { ReactComponent as DocumentAdd } from './assets/document-add.svg';
import { ReactComponent as Duplicate } from './assets/duplicate.svg';
import { ReactComponent as EmptyData } from './assets/empty-data.svg';
import { ReactComponent as ErrorState } from './assets/error-state.svg';
import { ReactComponent as Home } from './assets/home.svg';
import { ReactComponent as InformationCircle } from './assets/information-circle.svg';
import { ReactComponent as LightBulb } from './assets/light-bulb.svg';
import { ReactComponent as OpenLink } from './assets/open-link.svg';
import { ReactComponent as PlugFill } from './assets/plug-fill.svg';
import { ReactComponent as Road } from './assets/road.svg';
import { ReactComponent as Rss } from './assets/rss.svg';
import { ReactComponent as Server } from './assets/server.svg';
import { ReactComponent as SolidBookmark } from './assets/solid-bookmark.svg';
import { ReactComponent as SolidChat } from './assets/solid-chat.svg';
import { ReactComponent as SolidClock } from './assets/solid-clock.svg';
import { ReactComponent as SolidEye } from './assets/solid-eye.svg';
import { ReactComponent as Union } from './assets/union.svg';
import { ReactComponent as VerticalDots } from './assets/vertical-dots.svg';
import { ReactComponent as Export } from './assets/export.svg';
import { ReactComponent as XMark } from './assets/x-mark.svg';

export interface IIconName {
  iconName:
    | 'x-mark'
    | 'export'
    | 'union'
    | 'code-slash'
    | 'light-bulb'
    | 'plug-fill'
    | 'rss'
    | 'color-swatch'
    | 'chevron-up'
    | 'chevron-down'
    | 'information-circle'
    | 'solid-clock'
    | 'solid-bookmark'
    | 'solid-eye'
    | 'server'
    | 'home'
    | 'cube-transparent'
    | 'open-link'
    | 'empty-data'
    | 'error-state'
    | 'duplicate'
    | 'road'
    | 'solid-chat'
    | 'document-add'
    | 'chevron-double-left'
    | 'vertical-dots';
}

export type IconProps = IIconName & React.ComponentProps<'svg'>;

const Icon = (props: IconProps): ReactElement => {
  const { iconName, ...svgProps } = props;
  const Icons: Record<IIconName['iconName'], React.ReactElement> = {
    'code-slash': <CodeSlash {...svgProps} />,
    'x-mark': <XMark {...svgProps} />,
    export: <Export {...svgProps} />,
    'color-swatch': <ColorSwatch {...svgProps} />,
    'light-bulb': <LightBulb {...svgProps} />,
    'plug-fill': <PlugFill {...svgProps} />,
    'document-add': <DocumentAdd {...svgProps} />,
    rss: <Rss {...svgProps} />,
    'solid-clock': <SolidClock {...svgProps} />,
    'solid-bookmark': <SolidBookmark {...svgProps} />,
    'solid-eye': <SolidEye {...svgProps} />,
    server: <Server {...svgProps} />,
    'information-circle': <InformationCircle {...svgProps} />,
    'cube-transparent': <CubeTransparent {...svgProps} />,
    union: <Union {...svgProps} />,
    'open-link': <OpenLink {...svgProps} />,
    home: <Home {...svgProps} />,
    'empty-data': <EmptyData {...svgProps} />,
    'error-state': <ErrorState {...svgProps} />,
    duplicate: <Duplicate {...svgProps} />,
    road: <Road {...svgProps} />,
    'solid-chat': <SolidChat {...svgProps} />,
    'chevron-double-left': <ChevronDoubleLeft {...svgProps} />,
    'chevron-up': <ChevronUp {...svgProps} />,
    'chevron-down': <ChevronDown {...svgProps} />,
    'vertical-dots': <VerticalDots {...svgProps} />
  };
  return Icons[iconName];
};

export default Icon;
